"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const runtypes_1 = require("runtypes");
const DateAsString_1 = require("../../shared/DateAsString");
exports.User = (0, runtypes_1.Record)({
    id: runtypes_1.String,
    firstName: runtypes_1.String.nullable(),
    lastName: runtypes_1.String.nullable(),
    email: runtypes_1.String,
    creationDate: DateAsString_1.DateAsString,
    analyticsId: runtypes_1.String,
});
